import React from 'react';

import { Chart, Series, Export, ArgumentAxis, Label, Legend, Tooltip, ValueAxis } from 'devextreme-react/chart';
import { Button } from 'devextreme-react/button';
import { Card } from 'react-bootstrap';

import dataSource from '../helpers/graphHelper.js';
import { exportData, renderFullScreen } from '../helpers/utils.js';

const colors = ['#d505f5', '#0589f5'];

class BarChartNotice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          isFirstLevel: true,
          selectedInstance: '',
          data: ""
        };
    
        this.customizePoint = this.customizePoint.bind(this);
        this.onPointClick = this.onPointClick.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    async componentDidMount() {
        let resp = await dataSource.filterData("");
        if(resp) {
            let respForm = resp.sort(function(a, b) { return a.val < b.val ? 1 : -1; })
            this.setState({data: respForm});
        }
    }

    render() {
    return (
        <Card className="rounded-4">
            <Card.Body>
            <Card.Title>
                Communicated Notices ({global.config.dashboard.range} Days)
                <div className='float-end'>
                    <span className="fullscreen-link" onClick={() => {renderFullScreen("#chartNotices")}}>Full Screen</span>
                        <span> | </span>
                    <span className="fullscreen-link" onClick={() => {exportData("CommunicatedNotices", 
                        this.state.data, 
                        global.config.dashboard.range, 
                        this.state.isFirstLevel, 
                        this.state.selectedInstance
                    )}}>{this.state.isFirstLevel ? "Export" : "Export Workflow"}</span>
                </div>
            </Card.Title> 
            <Card.Subtitle>
                Number of Communicated Notices by Instance based on selected range. Click to drilldown for workflow breakdown                   
            </Card.Subtitle>    
            <div style={{position: "relative"}}>     
                <Chart
                    id="chartNotices"
                    title=""
                    customizePoint={this.customizePoint}
                    onPointClick={this.onPointClick}
                    className={this.state.isFirstLevel ? 'pointer-on-bars' : ''}
                    dataSource={this.state.data}
                >
                <Export enabled={true} />
                <Series type="bar" />
                <ArgumentAxis>
                    <Label
                        wordWrap="break"
                        overlappingBehavior={"rotate"}
                    />
                </ArgumentAxis>
                <ValueAxis type="logarithmic" />
                <Legend visible={false} />
                <Tooltip
                    enabled={true}
                    location="edge"
                    customizeTooltip={this.customizeTooltip}
                    zIndex={10000}
                />
                </Chart>    
                <Button type="light" className="button-container"
                    text="Back"
                    icon="chevronleft"
                    visible={!this.state.isFirstLevel}
                    onClick={this.onButtonClick}
                /> 
            </div>       
            </Card.Body>
        </Card>
    );
  }

    customizePoint() {
        return {
            color: colors[Number(this.state.isFirstLevel)],
            hoverStyle: !this.state.isFirstLevel ? {
            hatching: 'none',
            } : {},
        };
    }

    async onPointClick(e) {
        if(!e.element.classList.value.includes("fullscreen")) {      
            if (this.state.isFirstLevel) {
                let data = await dataSource.filterData(e.target.originalArgument);
                this.setState({
                    isFirstLevel: false,
                    selectedInstance: e.target.originalArgument,
                    data: data.sort(function(a, b) { return a.val < b.val ? 1 : -1; })
                });
            }
        }
    }

    async onButtonClick() {
        let data = await dataSource.filterData('');
        if (!this.state.isFirstLevel) {
            this.setState({
            isFirstLevel: true,
            data: data.sort(function(a, b) { return a.val < b.val ? 1 : -1; })
            });
        }
    }

    customizeTooltip(arg) {
        return {
            text: `${arg.argumentText} Notices: ${arg.valueText}`,
        }
    }
}

export default BarChartNotice;